module.exports = __webpack_public_path__ + "media/images/views/dashboard/junior-6e7ed8ed25e203dff493cc6898b0ee72.png";